import { DDDraggable } from 'gridstack';

type ClippingFn = (el: HTMLElement, scrollEl: HTMLElement) => number;

let patched = false;

/**
 * Auto-scroll fix for GridStack (verified up to v14.0.0) when the page itself
 * scrolls (the report editor scrolls `<html>`, not an inner container).
 *
 * `DDDraggable._getClipping` treats the dragged card as "fully outside" once
 * its top passes `<html>`'s bounding rect bottom. With `html { height: 100% }`
 * that rect is one viewport tall and moves up as the page scrolls, so after
 * roughly one card-height of scrolling GridStack stops auto-scrolling even
 * though the card is still at the bottom edge of the viewport (JEP-10485).
 * For the document scroller, clip against the viewport instead.
 */
export function patchGridStackDocumentScrollClipping(): void {
	if (patched) return;
	const proto = DDDraggable.prototype as unknown as {
		_getClipping?: ClippingFn;
	};
	const original = proto._getClipping;
	// GridStack internals changed: leave its own behaviour alone.
	if (typeof original !== 'function') return;
	patched = true;

	proto._getClipping = function (el, scrollEl) {
		const isDocumentScroller =
			scrollEl === document.scrollingElement ||
			scrollEl === document.documentElement;
		if (!isDocumentScroller) return original.call(this, el, scrollEl);

		const rect = el.getBoundingClientRect();
		const viewportH =
			window.innerHeight || document.documentElement.clientHeight;
		if (rect.bottom < 0 || rect.top > viewportH) return 0;
		if (rect.top < 0) return rect.top;
		if (rect.bottom > viewportH) return rect.bottom - viewportH;
		return 0;
	};
}
